import { defineStore } from 'pinia';

type Theme = 'light' | 'dark'

export const useThemeStore = defineStore('theme', {
    state: () => ({
        themeValue: 'dark' as Theme,
    }),
    actions: {
        initTheme() {
            this.themeValue = localStorage.getItem('theme') as Theme | null || 'dark';
            this.applyTheme();
        },
        switchTheme() {
            this.themeValue = this.themeValue === 'light' ? 'dark' : 'light';
            localStorage.setItem('theme', this.themeValue);
            this.applyTheme();
        },
        applyTheme() {
            document.body.setAttribute('data-theme', this.themeValue);
        },
    },
    getters: {
        theme: (state) => state.themeValue,
    },
});